import React, { useRef } from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";

/** Confirmation step before an action that contacts the customer or Giftery. */
export default function ConfirmDialog({ request, isBusy, onCancel, onConfirm }) {
  const cancelRef = useRef();
  return (
    <AlertDialog isOpen={Boolean(request)} leastDestructiveRef={cancelRef} onClose={onCancel} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {request ? request.title : ""}
          </AlertDialogHeader>
          <AlertDialogBody>{request ? request.body : ""}</AlertDialogBody>
          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onCancel} isDisabled={isBusy}>
              Cancel
            </Button>
            <Button colorScheme="orange" ml={3} onClick={onConfirm} isLoading={isBusy}>
              {request ? request.confirmLabel : "Confirm"}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
